import React, { useState } from 'react';
import { Container, Form, Button, Alert } from 'react-bootstrap';
import AboutHero from '../components/common/AboutHero';
import Recete3 from '../assets/images/recete3.jpg';
import { toUrl } from '../lib/config';

const AcilServisAnketPage: React.FC = () => {
  const [formData, setFormData] = useState({
    acileBaşvuru: 'Ambulans ile',
    cinsiyetiniz: 'Erkek',
    aitOldugunuz: '50-59',
    egitimDurumuzu: 'Lise',
    hastaneyeUlasimda: 'Tamamen Katılıyorum',
    danismaYonlendirme: 'Tamamen Katılıyorum',
    acilServisIcinde: 'Tamamen Katılıyorum',
    kayitIslemleri: 'Tamamen Katılıyorum',
    beklemeAlaninin: 'Tamamen Katılıyorum',
    muayeneVeMudahale: 'Tamamen Katılıyorum',
    muayeneOlduğum: 'Tamamen Katılıyorum',
    doktorununBana: 'Tamamen Katılıyorum',
    muayeneVeTetkikler: 'Tamamen Katılıyorum',
    tahlilVeTetkik: 'Tamamen Katılıyorum',
    tahlilVeTetkikSonuclarin: 'Tamamen Katılıyorum',
    doktorunTarafindan: 'Tamamen Katılıyorum',
    ihtiyacHalinde: 'Tamamen Katılıyorum',
    acilServisPersoneli: 'Tamamen Katılıyorum',
    acilServisGenel: 'Tamamen Katılıyorum',
    acilServisinSunmus: 'Tamamen Katılıyorum',
    acilServistenAyrilirken: 'Tamamen Katılıyorum',
    buAcilServisİ: 'Tamamen Katılıyorum',
    gorusVeOnerileriniz: ''
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    try {
      setLoading(true);
      setError('');
      setSuccess(false);

      const url = toUrl('/api/acil-servis-anket');
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error('Anket gönderilemedi. Lütfen tekrar deneyin.');
      }

      setSuccess(true);
      setFormData({
        acileBaşvuru: 'Ambulans ile',
        cinsiyetiniz: 'Erkek',
        aitOldugunuz: '50-59',
        egitimDurumuzu: 'Lise',
        hastaneyeUlasimda: 'Tamamen Katılıyorum',
        danismaYonlendirme: 'Tamamen Katılıyorum',
        acilServisIcinde: 'Tamamen Katılıyorum',
        kayitIslemleri: 'Tamamen Katılıyorum',
        beklemeAlaninin: 'Tamamen Katılıyorum',
        muayeneVeMudahale: 'Tamamen Katılıyorum',
        muayeneOlduğum: 'Tamamen Katılıyorum',
        doktorununBana: 'Tamamen Katılıyorum',
        muayeneVeTetkikler: 'Tamamen Katılıyorum',
        tahlilVeTetkik: 'Tamamen Katılıyorum',
        tahlilVeTetkikSonuclarin: 'Tamamen Katılıyorum',
        doktorunTarafindan: 'Tamamen Katılıyorum',
        ihtiyacHalinde: 'Tamamen Katılıyorum',
        acilServisPersoneli: 'Tamamen Katılıyorum',
        acilServisGenel: 'Tamamen Katılıyorum',
        acilServisinSunmus: 'Tamamen Katılıyorum',
        acilServistenAyrilirken: 'Tamamen Katılıyorum',
        buAcilServisİ: 'Tamamen Katılıyorum',
        gorusVeOnerileriniz: ''
      });

      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (err: any) {
      setError(err.message || 'Bir hata oluştu. Lütfen tekrar deneyin.');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement | HTMLTextAreaElement | HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <>
      <AboutHero
        image={Recete3}
        kicker="Bize ulaşın"
        title="İletişim"
        description="Megapark Hastanesi her an ve her zaman sizin yanınızda"
        overlayColor="#2cadd2"
        overlayOpacity={0.72}
        accentColor="#e30613"
        textColor="#ffffff"
        focus="center center"
        align="center"
        desktopHeight={460}
        tabletHeight={380}
        mobileHeight={320}
      />
      <div className="anket-page">
      <Container className="py-5">
        <div className="text-center mb-5">
          <h1 className="mb-3">
            Ayakta Hasta <span style={{ color: '#4CAF50' }}>Deneyim Anketi</span>
          </h1>
          <p className="text-muted" style={{ maxWidth: '800px', margin: '0 auto' }}>
            Aşağıdaki yer alan ifadeler ile ilgili geri bildirimleriniz, sizlere daha kaliteli hizmet sunmayı hedefleyen hastanemiz için büyük önem taşımaktadır.
          </p>
          <p className="text-muted" style={{ maxWidth: '800px', margin: '0 auto' }}>
            Bu konuda göstermiş olduğunuz ilgi ve katılımınız nedeniyle şimdiden teşekkür eder, geçmiş olsun dileklerimizi iletriz.
          </p>
          <p className="fw-bold mt-3">Başlıkım</p>
          <p className="text-muted">
            Not: Kişisel bilgileriniz ve ankette verdiğiniz bilgileri kesinlikle gizli tutulacaktır.
          </p>
        </div>

        {/* Başarı Mesajı */}
        {success && (
          <Alert variant="success" onClose={() => setSuccess(false)} dismissible>
            <Alert.Heading>Teşekkür Ederiz!</Alert.Heading>
            <p>
              Anketiniz başarıyla gönderildi. Görüşleriniz bizim için çok değerli.
            </p>
          </Alert>
        )}

        {/* Hata Mesajı */}
        {error && (
          <Alert variant="danger" onClose={() => setError('')} dismissible>
            <Alert.Heading>Hata!</Alert.Heading>
            <p>{error}</p>
          </Alert>
        )}

        <Form onSubmit={handleSubmit} className="survey-form">
          <div className="bg-light p-4 rounded-3 mb-4">
            {/* Acile Başvuru Şekli */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">Acile Başvuru Şekli</Form.Label>
              <Form.Select
                name="acileBaşvuru"
                value={formData.acileBaşvuru}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="">Kendi İmkanları ile</option>
                <option value="ambulans">Ambulans ile</option>
              </Form.Select>
            </Form.Group>

            {/* Cinsiyetiniz */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">Cinsiyetiniz</Form.Label>
              <Form.Select
                name="cinsiyetiniz"
                value={formData.cinsiyetiniz}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="">Kadın</option>
                <option value="erkek">Erkek</option>
              </Form.Select>
            </Form.Group>

            {/* Ait Olduğunuz Yaş Kategorisini Belirtiniz */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">Ait Olduğunuz Yaş Kategorisini Belirtiniz</Form.Label>
              <Form.Select
                name="aitOldugunuz"
                value={formData.aitOldugunuz}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="">20'nin altında</option>
                <option value="20-29">20-29 arası</option>
                <option value="30-39">30-39 arası</option>
                <option value="40-49">40-49 arası</option>
                <option value="50-59">50-59 arası</option>
                <option value="60+">60 üstü</option>
              </Form.Select>
            </Form.Group>

            {/* Eğitim Durumunuzu Belirtiniz */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">Eğitim Durumunuzu Belirtiniz</Form.Label>
              <Form.Select
                name="egitimDurumuzu"
                value={formData.egitimDurumuzu}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="">Okur-yazar değil</option>
                <option value="ilkokul">İlkokul</option>
                <option value="ortaokul">Ortaokul</option>
                <option value="lise">Lise</option>
                <option value="universite">Üniversite</option>
              </Form.Select>
            </Form.Group>
          </div>

          <div className="mb-5">
            <h4 className="mb-4 fw-bold">Anket Soruları</h4>

            {/* Soru 1 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                1.Hastaneye ulaşımda zorluk yaşadım.
              </Form.Label>
              <Form.Select
                name="hastaneyeUlasimda"
                value={formData.hastaneyeUlasimda}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="">Tamamen Katılıyorum</option>
                <option value="katiliyorum">Katılıyorum</option>
                <option value="kararsiiz">Kararsızım</option>
                <option value="katilmiyorum">Katılmıyorum</option>
                <option value="hic-katilmiyorum">Hiç Katılmıyorum</option>
              </Form.Select>
            </Form.Group>

            {/* Soru 2 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                2.Danışma ve yönlendirme hizmetleri yeterliydi.
              </Form.Label>
              <Form.Select
                name="danismaYonlendirme"
                value={formData.danismaYonlendirme}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="">Tamamen Katılıyorum</option>
                <option value="katiliyorum">Katılıyorum</option>
                <option value="kararsiiz">Kararsızım</option>
                <option value="katilmiyorum">Katılmıyorum</option>
                <option value="hic-katilmiyorum">Hiç Katılmıyorum</option>
              </Form.Select>
            </Form.Group>

            {/* Soru 3 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                3.Acil Servis içinde ulaşmak gereken birimiere kolaylıkla ulaşabildim.
              </Form.Label>
              <Form.Select
                name="acilServisIcinde"
                value={formData.acilServisIcinde}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="">Tamamen Katılıyorum</option>
                <option value="katiliyorum">Katılıyorum</option>
                <option value="kararsiiz">Kararsızım</option>
                <option value="katilmiyorum">Katılmıyorum</option>
                <option value="hic-katilmiyorum">Hiç Katılmıyorum</option>
              </Form.Select>
            </Form.Group>

            {/* Soru 4 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                4.Kayıt işlemleri için çok beklemedim.
              </Form.Label>
              <Form.Select
                name="kayitIslemleri"
                value={formData.kayitIslemleri}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="">Tamamen Katılıyorum</option>
                <option value="katiliyorum">Katılıyorum</option>
                <option value="kararsiiz">Kararsızım</option>
                <option value="katilmiyorum">Katılmıyorum</option>
                <option value="hic-katilmiyorum">Hiç Katılmıyorum</option>
              </Form.Select>
            </Form.Group>

            {/* Soru 5 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                5.Bekleme alanının fiziki koşulları yeterliydi.
              </Form.Label>
              <Form.Select
                name="beklemeAlaninin"
                value={formData.beklemeAlaninin}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="">Tamamen Katılıyorum</option>
                <option value="katiliyorum">Katılıyorum</option>
                <option value="kararsiiz">Kararsızım</option>
                <option value="katilmiyorum">Katılmıyorum</option>
                <option value="hic-katilmiyorum">Hiç Katılmıyorum</option>
              </Form.Select>
            </Form.Group>

            {/* Soru 6 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                6.Muayene ve müdahale için beklediğim süre uygundu.
              </Form.Label>
              <Form.Select
                name="muayeneVeMudahale"
                value={formData.muayeneVeMudahale}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="">Tamamen Katılıyorum</option>
                <option value="katiliyorum">Katılıyorum</option>
                <option value="kararsiiz">Kararsızım</option>
                <option value="katilmiyorum">Katılmıyorum</option>
                <option value="hic-katilmiyorum">Hiç Katılmıyorum</option>
              </Form.Select>
            </Form.Group>

            {/* Soru 7 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                7.Muayene olduğum alanın fiziki koşulları yeterliydi.
              </Form.Label>
              <Form.Select
                name="muayeneOlduğum"
                value={formData.muayeneOlduğum}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="">Tamamen Katılıyorum</option>
                <option value="katiliyorum">Katılıyorum</option>
                <option value="kararsiiz">Kararsızım</option>
                <option value="katilmiyorum">Katılmıyorum</option>
                <option value="hic-katilmiyorum">Hiç Katılmıyorum</option>
              </Form.Select>
            </Form.Group>

            {/* Soru 8 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                8.Doktorunun bana ayrıdığı süre yeterliydi.
              </Form.Label>
              <Form.Select
                name="doktorununBana"
                value={formData.doktorununBana}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="">Tamamen Katılıyorum</option>
                <option value="katiliyorum">Katılıyorum</option>
                <option value="kararsiiz">Kararsızım</option>
                <option value="katilmiyorum">Katılmıyorum</option>
                <option value="hic-katilmiyorum">Hiç Katılmıyorum</option>
              </Form.Select>
            </Form.Group>

            {/* Soru 9 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                9.Muayene ve tetkikler sırasında kişisel mahremiyetime özen gösterildi.
              </Form.Label>
              <Form.Select
                name="muayeneVeTetkikler"
                value={formData.muayeneVeTetkikler}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="">Tamamen Katılıyorum</option>
                <option value="katiliyorum">Katılıyorum</option>
                <option value="kararsiiz">Kararsızım</option>
                <option value="katilmiyorum">Katılmıyorum</option>
                <option value="hic-katilmiyorum">Hiç Katılmıyorum</option>
              </Form.Select>
            </Form.Group>

            {/* Soru 10 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                10.Tahlil ve tetkik için verilen randevu süreleri uygundu.
              </Form.Label>
              <Form.Select
                name="tahlilVeTetkik"
                value={formData.tahlilVeTetkik}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="">Tamamen Katılıyorum</option>
                <option value="katiliyorum">Katılıyorum</option>
                <option value="kararsiiz">Kararsızım</option>
                <option value="katilmiyorum">Katılmıyorum</option>
                <option value="hic-katilmiyorum">Hiç Katılmıyorum</option>
              </Form.Select>
            </Form.Group>

            {/* Soru 11 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                11.Tahlil ve tetkik sonuçlarını belirtilen süre içerisinde aldım.
              </Form.Label>
              <Form.Select
                name="tahlilVeTetkikSonuclarin"
                value={formData.tahlilVeTetkikSonuclarin}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="">Tamamen Katılıyorum</option>
                <option value="katiliyorum">Katılıyorum</option>
                <option value="kararsiiz">Kararsızım</option>
                <option value="katilmiyorum">Katılmıyorum</option>
                <option value="hic-katilmiyorum">Hiç Katılmıyorum</option>
              </Form.Select>
            </Form.Group>

            {/* Soru 12 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                12.Doktorun tarafından hastalığım ve tedavim ile ilgili yeterli bilgilendirme yapıldı.
              </Form.Label>
              <Form.Select
                name="doktorunTarafindan"
                value={formData.doktorunTarafindan}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="">Tamamen Katılıyorum</option>
                <option value="katiliyorum">Katılıyorum</option>
                <option value="kararsiiz">Kararsızım</option>
                <option value="katilmiyorum">Katılmıyorum</option>
                <option value="hic-katilmiyorum">Hiç Katılmıyorum</option>
              </Form.Select>
            </Form.Group>

            {/* Soru 13 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                13.İhtiyaç halinde gerekli sağlık personeline kolaylıkla ulaştım.
              </Form.Label>
              <Form.Select
                name="ihtiyacHalinde"
                value={formData.ihtiyacHalinde}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="">Tamamen Katılıyorum</option>
                <option value="katiliyorum">Katılıyorum</option>
                <option value="kararsiiz">Kararsızım</option>
                <option value="katilmiyorum">Katılmıyorum</option>
                <option value="hic-katilmiyorum">Hiç Katılmıyorum</option>
              </Form.Select>
            </Form.Group>

            {/* Soru 14 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                14.Acil Servis personeli nezaket kurallarına uygun davrandı.
              </Form.Label>
              <Form.Select
                name="acilServisPersoneli"
                value={formData.acilServisPersoneli}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="">Tamamen Katılıyorum</option>
                <option value="katiliyorum">Katılıyorum</option>
                <option value="kararsiiz">Kararsızım</option>
                <option value="katilmiyorum">Katılmıyorum</option>
                <option value="hic-katilmiyorum">Hiç Katılmıyorum</option>
              </Form.Select>
            </Form.Group>

            {/* Soru 15 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                15.Acil Servis genel olarak temizdi.
              </Form.Label>
              <Form.Select
                name="acilServisGenel"
                value={formData.acilServisGenel}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="">Tamamen Katılıyorum</option>
                <option value="katiliyorum">Katılıyorum</option>
                <option value="kararsiiz">Kararsızım</option>
                <option value="katilmiyorum">Katılmıyorum</option>
                <option value="hic-katilmiyorum">Hiç Katılmıyorum</option>
              </Form.Select>
            </Form.Group>

            {/* Soru 16 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                16.Acil Servisin sunmuş olduğu hizmetleri beğendim karşılıklı.
              </Form.Label>
              <Form.Select
                name="acilServisinSunmus"
                value={formData.acilServisinSunmus}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="">Tamamen Katılıyorum</option>
                <option value="katiliyorum">Katılıyorum</option>
                <option value="kararsiiz">Kararsızım</option>
                <option value="katilmiyorum">Katılmıyorum</option>
                <option value="hic-katilmiyorum">Hiç Katılmıyorum</option>
              </Form.Select>
            </Form.Group>

            {/* Soru 17 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                17.Acil Servisten ayrılırken taburculuk sonrası süreç ile ilgili yeterli bilgilendirme yapıldı.
              </Form.Label>
              <Form.Select
                name="acilServistenAyrilirken"
                value={formData.acilServistenAyrilirken}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="">Tamamen Katılıyorum</option>
                <option value="katiliyorum">Katılıyorum</option>
                <option value="kararsiiz">Kararsızım</option>
                <option value="katilmiyorum">Katılmıyorum</option>
                <option value="hic-katilmiyorum">Hiç Katılmıyorum</option>
              </Form.Select>
            </Form.Group>

            {/* Soru 18 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                18.Bu Acil Servisi ailem ve arkadaşlarıma tavsiye ederim.
              </Form.Label>
              <Form.Select
                name="buAcilServisİ"
                value={formData.buAcilServisİ}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="">Tamamen Katılıyorum</option>
                <option value="katiliyorum">Katılıyorum</option>
                <option value="kararsiiz">Kararsızım</option>
                <option value="katilmiyorum">Katılmıyorum</option>
                <option value="hic-katilmiyorum">Hiç Katılmıyorum</option>
              </Form.Select>
            </Form.Group>

            {/* Görüş ve Önerileriniz */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                Varsa görüş ve önerileriniz:
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={5}
                name="gorusVeOnerileriniz"
                value={formData.gorusVeOnerileriniz}
                onChange={handleChange}
                placeholder="Görüş ve önerilerinizi buraya yazabilirsiniz..."
                className="form-control-lg"
              />
            </Form.Group>

            {/* Submit Button */}
            <div className="d-grid gap-2 mt-5">
              <Button
                type="button"
                size="lg"
                disabled={loading}
                onClick={(e) => {
                  handleSubmit(e as any);
                }}
                style={{
                  backgroundColor: '#4CAF50',
                  borderColor: '#4CAF50',
                  fontWeight: '600'
                }}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Gönderiliyor...
                  </>
                ) : (
                  'Anketi Gönder'
                )}
              </Button>
            </div>
          </div>
        </Form>
      </Container>
    </div>
    </>
  );
};

export default AcilServisAnketPage;
